<template>
  <div class="sw-grid-flex sw-grid-flex--dir-column admin-material-table">
    <b-table
      striped hover
      :items="guidelines"
      :fields="headers">
      <template v-slot:cell(select)="data">
        <input
          type="radio"
          :value="data.item.id"
          :id="'check-'+ data.index"
          :disabled="showAddNewGuideline"
          v-model="selectedGuideline">
      </template>
      <template v-slot:custom-foot v-if="showAddNewGuideline">
        <b-tr>
          <b-td></b-td>
          <b-td></b-td>
          <b-td v-for="field in newGuideline.fields" :key="field.name">
              <select v-if="field.type === 'select'" v-model="field.value" class="sw-select--not-round sw--width-full">
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            <textarea v-else-if="field.type === 'textarea'"  v-model="field.value" class="sw--width-full"></textarea>
              <input v-else v-model.number="field.value" class="sw--input-height__medium sw--font-size-14 sw--width-full">
          </b-td>
          <b-td>

          </b-td>
        </b-tr>

      </template>
    </b-table>
    <bottom-banner
      :missing-info="!materialId ? ['Basic Information'] : []"
      v-on:saved="saveGuideline"
      :show-saved-message="showSavedMessage"
      v-on:add-new="showAddNew"
      v-on:cancel="cancelAddingNew"
      :show-cancel-btn="showCancelBtn"
      :show-add-new-btn="showAddNewBtn"/>
  </div>
</template>

<script>

    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner.vue";

    export default {
        name: "material-guideline",
        components: {BottomBanner},
        mixins: [VueSwMixin, VueJQueryMixin],
        props: {
            guidelines: {
                type:Array,
                required: true,
            },
            materialId: {
                type: Number,
                required: false
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            }
        },
        created() {
            if (this.currentMaterial) {
                this.selectedGuideline = parseInt(this.currentMaterial.designGuidelineId);
            }
        },
        data: () => ({
            selectedGuideline: null,
            showSavedMessage: false,
            showAddNewBtn: true,
            showAddNewGuideline: false,
            newGuideline: {
                fields: [
                    {
                        title: 'Min Density Percent',
                        name: 'minDensityPercent',
                        value: 0,
                    },
                    {
                        title: 'Min Details Embossed Um',
                        name: 'minDetailsEmbossed',
                        value: 0,
                    },
                    {
                        title: 'Min Details Engraved Um',
                        name: 'minDetailsEngraved',
                        value: 0,
                    },
                    {
                        title: 'Min Wall Free Um',
                        name: 'minWallFree',
                        value: 0,
                    },
                    {
                        title: 'Min Wall Supported Um',
                        name: 'minWallSupported',
                        value: 0,
                    },
                    {
                        title: 'Min Wire Free Um',
                        name: 'minWireFree',
                        value: 0,
                    },
                    {
                        title: 'Min Wire Supported Um',
                        name: 'minWireSupported',
                        value: 0,
                    },
                    {
                        title: 'Multiple Part Limit',
                        name: 'multiplePartLimit',
                        value: 0,
                    },
                    {
                        title: 'Supports Interlocking Parts',
                        name: 'supportsInterlockingParts',
                        value: false,
                        type: 'select'
                    },
                    {
                        title: 'Accuracy',
                        name: 'accuracy',
                        value: '',
                        type: 'textarea'
                    },
                    {
                        title: 'Clearance Um',
                        name: 'clearance',
                        value: 0,
                    }
                ]
            }
        }),
        computed: {
            headers() {
                let headers = ['select'];
                let keys = Object.keys(this.guidelines[0]);
                keys.forEach(key => {
                    headers.push(key);
                });
                return headers;
            },
            showCancelBtn() {
                return this.showAddNewGuideline && !this.showAddNewBtn
            }
        },
        methods: {
            cancelAddingNew() {
                this.showAddNewGuideline = false;
                this.showAddNewBtn = true;
            },
            showAddNew() {
                this.showAddNewGuideline = true;
                this.showAddNewBtn = false;
            },
            mapNewGuidelineToObj() {
                let result = {};
                this.newGuideline.fields.forEach(field => {
                    result[field.name] = field.value
                })
                return result;
            },
            saveGuideline() {
                let _this = this;
                let _data = {};

                if (this.selectedGuideline) _data['guidelineId'] = this.selectedGuideline;
                if (this.showAddNewGuideline) {
                    _data['newGuideline'] = this.mapNewGuidelineToObj()
                }
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/' + _this.materialId + '/guideline',
                    dataType: 'json',
                    data: _data,
                    success: (data) => {
                        _this.$emit('success', data);
                        _this.showSavedMessage = true;
                        this.$sw.notifications.success('Saved!')
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });

            }
        }
    }
</script>
